import YouTubeVideoPlayer from "../YouTubeVideoPlayer";

class VerticalGames {
    constructor(el) {
        this.el = el;
        // development in progress do not use
        // this.init();
    }

    init() {
        const videoSection = this.el.querySelector('.video-section');

        if (videoSection) {
            const youtubeVideoId = videoSection.dataset.videoId;
            const autoplay = videoSection.dataset.autoplay === 'true';
            const muted = videoSection.dataset.muted === 'true';

            const videoPlayer = new YouTubeVideoPlayer(videoSection, youtubeVideoId, autoplay, muted);
            videoPlayer.init();
        }
    }
}

export default VerticalGames;
